"use strict";
exports.__esModule = true;
exports.FinancialPublication = void 0;
var FinancialPublication;
(function (FinancialPublication) {
    FinancialPublication["FullYearResult"] = "full-year-results";
    FinancialPublication["GreendBond"] = "green-bond";
    FinancialPublication["HalfResult"] = "half-results";
    FinancialPublication["InvestorPresentations"] = "investor-presentations";
    FinancialPublication["ReferenceDocument"] = "reference-document";
    FinancialPublication["RseReport"] = "rse-report";
    FinancialPublication["Urd"] = "urd";
    FinancialPublication["EnterpriseGovernmentReport"] = "rapport-gouvernement-entrprise";
    FinancialPublication["VotingRightNbActions"] = "droits-vote-nb-actions";
})(FinancialPublication = exports.FinancialPublication || (exports.FinancialPublication = {}));
//# sourceMappingURL=financial-publication.js.map